/*
  value is what percent of maximumValue?
  value is P% of maximumValue
  Equation: Y = P% * X
*/
export const calculatePercentage = (value, maximumValue, percentage = 100) => {
  // P%
  const valuePercent = value / maximumValue;
  // Convert decimal to percent
  return valuePercent * percentage;
};
